import React from 'react'

import { Link } from 'gatsby'

import { BreadcrumbsType } from '@contracts/components/breadcrumbs'
import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './Breadcrumb.module.scss'

interface Props extends CustomizableComponent {
	data: BreadcrumbsType
	theme: 'light' | 'dark'
}
const Breadcrumbs: React.FC<Props> = (props) => {
	const breadcrumbs = props.data

	const breadcrumbStyles = [styles.breadcrumbs]

	if (props.theme === 'light') {
		breadcrumbStyles.push(styles.light)
	}

	if (props.className) {
		breadcrumbStyles.push(props.className)
	}

	return (
		<menu className={breadcrumbStyles.join(' ')}>
			{breadcrumbs.map((breadcrumb, index) => {
				return (
					<li className={styles.breadcrumb} key={index}>
						{breadcrumb.link === '' ? (
							<span>{breadcrumb.label}</span>
						) : (
							<Link to={breadcrumb.link}>{breadcrumb.label}</Link>
						)}
					</li>
				)
			})}
		</menu>
	)
}

export default Breadcrumbs
